import { render } from "./WalletWithdraw.vue?vue&type=template&id=2fac3d24"
import script from "./WalletWithdraw.vue?vue&type=script&lang=js"
export * from "./WalletWithdraw.vue?vue&type=script&lang=js"

import "./WalletWithdraw.vue?vue&type=style&index=0&id=2fac3d24&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__